import type { StatusTone } from "@/components/ui";
import type { AvailabilityStatus, BookableResourceStatus } from "./types";

export function resourceStatusTone(status: BookableResourceStatus): StatusTone {
  switch (status) {
    case "available":
      return "success";
    case "pending_setup":
    case "paused":
      return "warning";
    case "unavailable":
    case "under_maintenance":
    case "restricted":
      return "danger";
    case "retired":
      return "neutral";
    default:
      return "neutral";
  }
}

export function scheduleStatusTone(status: AvailabilityStatus | string): StatusTone {
  switch (status) {
    case "active":
    case "resolved":
      return "success";
    case "scheduled":
    case "reported":
    case "modified":
    case "paused":
      return "warning";
    case "cancelled":
    case "restricted":
      return "danger";
    case "expired":
    case "retired":
    case "archived":
      return "neutral";
    default:
      return "neutral";
  }
}

export function formatLabel(value: string): string {
  return value.replaceAll("_", " ");
}

/** Convert datetime-local (or any parseable date) to UTC ISO with offset. */
export function toIsoUtc(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";
  const date = new Date(trimmed);
  if (Number.isNaN(date.getTime())) return trimmed;
  return date.toISOString();
}
